module.exports = __webpack_public_path__ + "img/home_hnews9_1.8cc8dce2.png";